import { useQueryClient } from '@tanstack/react-query';
import { RQAPICall } from 'store/APIClient';
import { useBaseSupportMutation } from './baseMutation';

export const useUpdateUsageHistoryMutation = (bind: string) => {
    const queryClient = useQueryClient();
    return useBaseSupportMutation(
        (hasUsageHistory: boolean) =>
            RQAPICall({
                endpoint: `support/${bind}/usage_history`,
                method: 'PUT',
                body: { hasUsageHistory },
            }),
        () => {
            queryClient.invalidateQueries({
                queryKey: ['meta-client', bind],
            });
        },
    );
};
